/* eslint no-bitwise: "off" */

import React from 'react';
import PropTypes from 'prop-types';
import Dialog from './Dialog';
import Button from './button';
import TextField from './TextField';
import { post } from '../../utils/ajax';
import MessagePanel from '../messagePanel';
import { showSuccessNotification } from '../../reducers/notifications';
import LinearProgress from '@material-ui/core/LinearProgress';

class ResetPasswordDialog extends React.Component {
	constructor(props, context) {
		super(props, context);

		this.state = {
			isLoading: false,
			errorMessage: '',

			password: '',
			confirmPassword: '',

			passwordValid: true,
			passwordsMatch: true
		};

		this.validatePassword = this.validatePassword.bind(this);
		this.validateConfirmPassword = this.validateConfirmPassword.bind(this);
		this.onOk = this.onOk.bind(this);
	}
	UNSAFE_componentWillReceiveProps(nextProps) {
		if (!this.props.show && nextProps.show) {
			// Clear state each time dialog opened
			this.setState({
				password: '',
				confirmPassword: '',

				passwordValid: true,
				passwordsMatch: true
			});
		}
	}

	validatePassword() {
		if (!this.state.password || this.state.password.length < 8) {
			this.setState({ passwordValid: false });
			return false;
		}
		return true;
	}
	validateConfirmPassword() {
		if (this.state.confirmPassword !== this.state.password) {
			this.setState({ passwordsMatch: false });
			return false;
		}
		return true;
	}

	onOk() {
		if (this.validatePassword() & this.validateConfirmPassword()) {
			this.setState({
				isLoading: true,
				errorMessage: ''
			});

			post({
				url: `/api/users/${this.props.user.userId}/change-password`,
				data: {
					newPassword: this.state.password
				},
				onSuccess: (data) => {
					if (data.success) {
						this.setState({
							isLoading: false
						});
						this.props.dispatch(showSuccessNotification('The password has been changed'));
						
						this.props.onOk();
					} else {
						this.setState({
							isLoading: false,
							errorMessage: data.error
						});
					}
				},
				onError: (error) => {
					this.setState({
						isLoading: false,
						errorMessage: error
					});
				}
			});
		}
	}

	render() {
		return (
<Dialog
	title={this.props.title}
	actions={
		<React.Fragment>
			<Button
				label='Ok'
				primary={true}
				onClick={() => this.onOk()}
			/>,
			<Button
				label='Cancel'
				onClick={() => this.props.onCancel()}
			/>
		</React.Fragment>
	}
	open={this.props.show}
    onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
			if (!this.state.isLoading) this.props.onCancel();
        }
    }}
>
	<span style={{ marginLeft: '10px' }}>{this.props.message}</span>

	<form>
	<TextField
		type="password"
		autoComplete="off"
		value={this.state.password}
		onChange={(e) => { 
			this.setState({ 
				password: e.target.value,
				passwordValid: true
			}); 
		}}
		onBlur={() => {
			this.validatePassword();
		}}
		label="Password"
		errorText={this.state.passwordValid ? '' : 'The password must be at least 8 characters'}
		fullWidth={true}
	/>

	<TextField
		type="password"
		autoComplete="off"
		value={this.state.confirmPassword}
		onChange={(e) => { 
			this.setState({ 
				confirmPassword: e.target.value,
				passwordsMatch: true
			}); 
		}}
		onBlur={() => {
			this.validateConfirmPassword();
		}}
		label="Confirm Password"
		errorText={this.state.passwordsMatch ? '' : 'Passwords do not match'}
		fullWidth={true}
	/>
	</form>

	{this.state.isLoading &&
		<LinearProgress 
			variant='indeterminate' 
			style={{ marginBottom: '10px' }} 
		/>
	}
			
	<MessagePanel isSuccess={false} message={this.state.errorMessage} />
</Dialog>
		);
	}
}

ResetPasswordDialog.propTypes = {
	dispatch: PropTypes.func.isRequired,
	show: PropTypes.bool.isRequired,
	onOk: PropTypes.func.isRequired,
	onCancel: PropTypes.func.isRequired,
	user: PropTypes.object,
	title: PropTypes.string.isRequired,
	message: PropTypes.string.isRequired
};

ResetPasswordDialog.defaultProps = {
	user: {}
};

export default ResetPasswordDialog;
